import styled from "styled-components";

export const ImgContainer = styled.div`
    /* width: calc(100% - ${props => props.padding * 2}px);
    height: calc(100% - ${props => props.padding * 2}px);
    top: ${props => props.padding}px;
    left: ${props => props.padding}px; */
    cursor: grab;
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    box-shadow: ${props => props.shadow};
    border: ${props => `${props.borderWidth}px solid ${props.borderColor}`};
    border-radius: ${props => props.borderRadius}px;
    img {
        pointer-events: none;
    }

    svg {
        filter: none!important;
    }

    .overlay {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: ${props => props.overlayColor};
        z-index: 1;
    }
`